import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  ko: {
    appName: '크래프트 푸드 팩토리',
    portalTitle: '주문 포털',
    login: '로그인',
    logout: '로그아웃',
    email: '이메일',
    password: '비밀번호',
    signIn: '로그인',
    dashboard: '대시보드',
    newOrder: '새 주문',
    orderHistory: '주문 내역',
    repeatOrder: '주문 반복',
    documents: '문서',
    outstandingBalance: '미결제 잔액',
    companies: '회사',
    products: '제품',
    productCategories: '제품 카테고리',
    orders: '주문',
    production: '생산',
    shipping: '배송',
    payments: '결제',
    users: '사용자',
    settings: '설정',
    save: '저장',
    cancel: '취소',
    delete: '삭제',
    edit: '편집',
    add: '추가',
    create: '만들기',
    submit: '제출',
    close: '닫기',
    confirm: '확인',
    search: '검색',
    name: '이름',
    phone: '전화',
    address: '주소',
    quantity: '수량',
    price: '가격',
    total: '합계',
    status: '상태',
    date: '날짜',
    actions: '작업',
    welcome: '환영합니다',
    selectLanguage: '언어 선택',
    monday: '월요일',
    thursday: '목요일',
    today: '오늘',
    deliveryLocation: '배송지',
    company: '회사',
    contactPerson: '담당자',
    paymentTerms: '결제 조건',
    notes: '메모',
    orderNumber: '주문 번호',
    plannedShipmentDate: '예정 배송일',
    totalAmount: '총 금액',
    deliveryCost: '배송비',
    subtotal: '소계',
    unitPrice: '단가',
    orderedQuantity: '주문 수량',
    actualShipped: '실제 배송 수량',
    pricingGroup: '가격 그룹',
    clientType: '고객 유형',
    deliveryMethod: '배송 방법',
    addToCart: '카트에 추가',
    placeOrder: '주문하기',
    orderSuccess: '주문이 성공적으로 생성되었습니다',
    copyPaymentInfo: '결제 정보 복사',
    copyDeliveryInfo: '배송 정보 복사',
    copied: '복사되었습니다',
    overdue: '연체',
    paid: '결제됨',
    unpaid: '미결제',
    productionTotals: '생산 합계',
    boxes: '박스',
    packs: '팩',
    markAsInProduction: '생산 중으로 표시',
    markAsPacked: '포장 완료로 표시',
    markAsShipped: '배송 완료로 표시',
    overallStats: '전체 통계',
    newOrders: '새 주문',
    shippingToday: '오늘 배송',
    totalRevenue: '총 수익',
    /* navigation */
    navHome: '홈',
    navAbout: '소개',
    navBrands: '브랜드',
    navContacts: '연락처',
    register: '가입',
    myPortal: '내 포털',
    /* hero / home */
    heroHeadline: '정직한 음식, 더 나은 삶',
    heroSub: '현대적인 라이프스타일을 위한 정직한 음식을 만듭니다.',
    heroCtaPrimary: '주문하기',
    heroCtaSecondary: '브랜드 알아보기',
    /* values */
    valuesTitle: '우리의 가치',
    valHonest: '정직한 구성',
    valNatural: '천연 재료',
    valBetterChoice: '더 나은 선택',
    valQuality: '타협 없는 품질',
    valTrust: '가족이 신뢰하는 제품',
    /* brand architecture */
    brandArchTitle: '우리의 브랜드',
    brandArchSub: '신선한 라바시와 천연 디저트',
    masterBrandTag: 'CRAFTFOOD',
    subBrandTag: '브랜드',
    ourBrands: '우리의 브랜드',
    lavashCardDesc: '가정, 카페, 레스토랑 및 외식업체를 위한 신선한 라바시.',
    veloraCardDesc: '현대적인 삶을 위한 천연 재료로 만든 디저트.',
    lavashShort: '모던 플랫브레드',
    veloraShort: '디저트',
    veloraSoon: '곧 출시',
    /* about */
    aboutTitle: '소개',
    missionTitle: '미션',
    missionBody: '현대적인 삶을 위한 정직한 음식을 만듭니다.',
    visionTitle: '비전',
    visionBody: '새로운 세대를 위한 브랜드를 만드는 국제적인 식품 회사.',
    philosophyTitle: '철학',
    philosophyBody: '깨끗한 재료. 단순한 레시피. 매일 더 나은 선택.',
    /* lavash page */
    lavashTagline: '더 나은 식사. 더 나은 삶.',
    lavashIntro: '건강한 식단을 위한 현대적인 기본 빵.',
    lavashAdv: 'LAVASH의 장점',
    advNoYeast: '이스트 없음',
    advNoPreservatives: '방부제 없음',
    advClean: '깨끗한 재료',
    advVersatile: '다재다능함',
    catalogPreview: '제품 카탈로그',
    ctaLoginToOrder: '주문하려면 로그인',
    /* velora page */
    veloraTagline: '더 나은 즐거움. 더 나은 삶.',
    veloraIntro: '새로운 세대의 모던 디저트.',
    veloraAdv: 'VELORA의 장점',
    advLessSugar: '저당',
    /* contacts */
    contactsTitle: '연락처',
    contactsForm: '메시지를 남겨주세요',
    contactName: '이름',
    contactMessage: '메시지',
    sendMessage: '보내기',
    /* footer */
    footerTagline: '한국에서 현대적인 라이프스타일을 위한 정직한 음식을 만듭니다.',
    footerBrands: '브랜드',
    footerCompany: '회사',
    /* catalog / cart */
    catalogTitle: '카탈로그',
    cart: '장바구니',
    yourCart: '내 장바구니',
    cartEmpty: '장바구니가 비어 있습니다',
    checkout: '결제',
    perBox: '/박스',
    inCart: '장바구니에',
    comingSoon: '곧 출시',
    notifyMe: '출시 시 알림 받기',
    /* localized slogans (brand names stay in latin) */
    tagCraftfood: '정직한 음식, 더 나은 삶',
    tagCraftfoodShort: '정직한 음식 · 더 나은 삶',
    tagLavashSub: '모던 플랫브레드',
    tagLavashSlogan: '더 잘 먹자. 더 잘 살자.',
    tagVeloraSub: '정성으로 만든',
    tagVeloraSlogan: '더 즐겁게. 더 잘 살자.',
    heroLine1: '정직한 음식,',
    heroLine2: '더 나은',
    heroLine3: '삶을 위해.',
    loginAside: '정직한 음식. 더 나은 삶.',
    becomePartner: '파트너가 되어주세요.',
    masterBrand: 'CRAFTFOOD',
    subBrand: '브랜드',
    oneMasterTwoBrands: '우리의 브랜드',
    betterBreadBetterLife: '더 나은 빵. 더 나은 삶.',
    sixSizes: '6가지 사이즈. 하나의 캐릭터.',
    readyToOrder: '주문할 준비가 되셨나요?',
    registerInMinute: '1분 안에 비즈니스를 등록하세요. 바로 LAVASH 주문을 시작하세요.',
    brandsH1Line1: '하나의 가족.',
    brandsH1Line2: '다양한 맛.',
    contactsH1Line1: '함께',
    contactsH1Line2: '이야기해요.',
    lavashTagLine: '모던 플랫브레드 · 더 잘 먹자. 더 잘 살자.',
    veloraTagLine: '모던 디저트 · 더 즐겁게. 더 잘 살자.',
    loginAsideSub: 'CRAFTFOOD 파트너를 위한 B2B 주문 포털. 하나의 로그인. 두 개의 브랜드. 끝없는 신선함.',
    veloraComingSoonHint: 'VELORA 디저트는 곧 통합 장바구니에서 사용 가능합니다. 하나의 주문. 두 개의 브랜드.',
    b2bNoticeTag: 'B2B 도매 플랫폼',
    b2bNoticeTitle: '가격 및 구매 조건은 회원 가입 후 확인하실 수 있습니다',
    b2bNoticeBody: 'CRAFTFOOD는 식당, 카페, 매장을 위한 B2B 도매 주문 플랫폼입니다. 사업자 회원가입 후 제품별 도매가격, 수량별 할인, 배송 조건 및 결제 방법을 확인하실 수 있습니다. 등록은 1분이면 충분하며 즉시 주문 가능합니다.',
    b2bAdvWholesale: '도매 가격',
    b2bAdvVolume: '수량 할인',
    b2bAdvDelivery: '정기 배송',
    b2bAdvInvoice: '세금계산서 발행',
  },
  ru: {
    appName: 'Craft Food Factory',
    portalTitle: 'Портал заказов',
    login: 'Войти',
    logout: 'Выйти',
    email: 'Email',
    password: 'Пароль',
    signIn: 'Войти',
    dashboard: 'Панель управления',
    newOrder: 'Новый заказ',
    orderHistory: 'История заказов',
    repeatOrder: 'Повторить заказ',
    documents: 'Документы',
    outstandingBalance: 'Задолженность',
    companies: 'Компании',
    products: 'Продукты',
    productCategories: 'Категории продуктов',
    orders: 'Заказы',
    production: 'Производство',
    shipping: 'Доставка',
    payments: 'Платежи',
    users: 'Пользователи',
    settings: 'Настройки',
    save: 'Сохранить',
    cancel: 'Отмена',
    delete: 'Удалить',
    edit: 'Редактировать',
    add: 'Добавить',
    create: 'Создать',
    submit: 'Отправить',
    close: 'Закрыть',
    confirm: 'Подтвердить',
    search: 'Поиск',
    name: 'Имя',
    phone: 'Телефон',
    address: 'Адрес',
    quantity: 'Количество',
    price: 'Цена',
    total: 'Итого',
    status: 'Статус',
    date: 'Дата',
    actions: 'Действия',
    welcome: 'Добро пожаловать',
    selectLanguage: 'Выбрать язык',
    monday: 'Понедельник',
    thursday: 'Четверг',
    today: 'Сегодня',
    deliveryLocation: 'Адрес доставки',
    company: 'Компания',
    contactPerson: 'Контактное лицо',
    paymentTerms: 'Условия оплаты',
    notes: 'Заметки',
    orderNumber: 'Номер заказа',
    plannedShipmentDate: 'Планируемая дата отгрузки',
    totalAmount: 'Общая сумма',
    deliveryCost: 'Стоимость доставки',
    subtotal: 'Подытог',
    unitPrice: 'Цена за единицу',
    orderedQuantity: 'Заказано',
    actualShipped: 'Фактически отгружено',
    pricingGroup: 'Группа цен',
    clientType: 'Тип клиента',
    deliveryMethod: 'Способ доставки',
    addToCart: 'Добавить',
    placeOrder: 'Оформить заказ',
    orderSuccess: 'Заказ успешно создан',
    copyPaymentInfo: 'Копировать платёжную информацию',
    copyDeliveryInfo: 'Копировать информацию о доставке',
    copied: 'Скопировано',
    overdue: 'Просрочено',
    paid: 'Оплачено',
    unpaid: 'Не оплачено',
    productionTotals: 'Итоги производства',
    boxes: 'коробок',
    packs: 'пачек',
    markAsInProduction: 'В производстве',
    markAsPacked: 'Упаковано',
    markAsShipped: 'Отгружено',
    overallStats: 'Общая статистика',
    newOrders: 'Новые заказы',
    shippingToday: 'Отгрузка сегодня',
    totalRevenue: 'Общая выручка',
    /* navigation */
    navHome: 'Главная',
    navAbout: 'О компании',
    navBrands: 'Бренды',
    navContacts: 'Контакты',
    register: 'Регистрация',
    myPortal: 'Мой кабинет',
    /* hero / home */
    heroHeadline: 'Честная еда для лучшей жизни',
    heroSub: 'Создаём честную еду для современной жизни. Простые составы. Понятные продукты. Лучшие решения для здоровья.',
    heroCtaPrimary: 'Оформить заказ',
    heroCtaSecondary: 'Узнать о брендах',
    /* values */
    valuesTitle: 'Наши ценности',
    valHonest: 'Честный состав',
    valNatural: 'Натуральные ингредиенты',
    valBetterChoice: 'Более полезный выбор',
    valQuality: 'Качество без компромиссов',
    valTrust: 'Доверие семей',
    /* brand architecture */
    brandArchTitle: 'Наши бренды',
    brandArchSub: 'Свежий лаваш и натуральные десерты',
    masterBrandTag: 'CRAFTFOOD',
    subBrandTag: 'Бренд',
    ourBrands: 'Наши бренды',
    lavashCardDesc: 'Свежий лаваш для дома, кафе, ресторанов и предприятий общественного питания.',
    veloraCardDesc: 'Десерты из натуральных ингредиентов для современной жизни.',
    lavashShort: 'Modern Flatbread',
    veloraShort: 'Desserts',
    veloraSoon: 'Скоро в продаже',
    /* about */
    aboutTitle: 'О компании',
    missionTitle: 'Миссия',
    missionBody: 'Создаём честную еду для современной жизни.',
    visionTitle: 'Видение',
    visionBody: 'Международная food-компания нового поколения, создающая бренды, которым доверяют.',
    philosophyTitle: 'Философия',
    philosophyBody: 'Чистые ингредиенты. Простые рецепты. Лучший выбор каждый день.',
    /* lavash page */
    lavashTagline: 'Eat Better. Live Better.',
    lavashIntro: 'Современная основа для здорового питания. Более полезная альтернатива обычному хлебу.',
    lavashAdv: 'Преимущества LAVASH',
    advNoYeast: 'Без дрожжей',
    advNoPreservatives: 'Без консервантов',
    advClean: 'Простой состав',
    advVersatile: 'Универсальность',
    catalogPreview: 'Каталог продукции',
    ctaLoginToOrder: 'Войти для заказа',
    /* velora page */
    veloraTagline: 'Enjoy Better. Live Better.',
    veloraIntro: 'Современные десерты нового поколения. Десерт на каждый день — со заботой о вас.',
    veloraAdv: 'Преимущества VELORA',
    advLessSugar: 'Пониженное содержание сахара',
    /* contacts */
    contactsTitle: 'Контакты',
    contactsForm: 'Напишите нам',
    contactName: 'Ваше имя',
    contactMessage: 'Сообщение',
    sendMessage: 'Отправить',
    /* footer */
    footerTagline: 'Создаём бренды нового поколения для современной жизни в Корее.',
    footerBrands: 'Бренды',
    footerCompany: 'Компания',
    /* catalog / cart */
    catalogTitle: 'Каталог',
    cart: 'Корзина',
    yourCart: 'Ваша корзина',
    cartEmpty: 'Корзина пуста',
    checkout: 'Оформить',
    perBox: '/коробка',
    inCart: 'В корзине',
    comingSoon: 'Скоро в продаже',
    /* localized slogans (brand names stay in latin) */
    tagCraftfood: 'Честная еда для лучшей жизни',
    tagCraftfoodShort: 'Честная еда · Лучшая жизнь',
    tagLavashSub: 'Современный лаваш',
    tagLavashSlogan: 'Питайся лучше. Живи лучше.',
    tagVeloraSub: 'Создано с заботой',
    tagVeloraSlogan: 'Наслаждайся лучшим. Живи лучше.',
    heroLine1: 'Честная еда',
    heroLine2: 'для лучшей',
    heroLine3: 'жизни.',
    loginAside: 'Честная еда. Лучшая жизнь.',
    becomePartner: 'Станьте партнёром.',
    masterBrand: 'CRAFTFOOD',
    subBrand: 'БРЕНД',
    oneMasterTwoBrands: 'Наши бренды',
    betterBreadBetterLife: 'Лучший хлеб. Лучшая жизнь.',
    sixSizes: '6 размеров. Один характер.',
    readyToOrder: 'Готовы оформить заказ?',
    registerInMinute: 'Зарегистрируйте бизнес за минуту. Начните заказывать LAVASH прямо сейчас.',
    brandsH1Line1: 'Одна семья.',
    brandsH1Line2: 'Множество вкусов.',
    contactsH1Line1: 'Давайте',
    contactsH1Line2: 'поговорим.',
    lavashTagLine: 'Современный лаваш · Питайся лучше. Живи лучше.',
    veloraTagLine: 'Современные десерты · Наслаждайся лучшим. Живи лучше.',
    loginAsideSub: 'B2B портал заказов для партнёров CRAFTFOOD. Один логин. Два бренда. Бесконечная свежесть.',
    veloraComingSoonHint: 'Десерты VELORA скоро появятся в общей корзине. Один заказ. Два бренда.',
    b2bNoticeTag: 'B2B оптовая платформа',
    b2bNoticeTitle: 'Цены и условия покупки доступны после регистрации',
    b2bNoticeBody: 'CRAFTFOOD — это B2B платформа оптовых заказов для ресторанов, кафе и магазинов. После регистрации бизнеса вы увидите оптовые цены по каждому продукту, скидки по объёму, условия доставки и доступные способы оплаты. Регистрация занимает 1 минуту, заказывать можно сразу.',
    b2bAdvWholesale: 'Оптовые цены',
    b2bAdvVolume: 'Скидки по объёму',
    b2bAdvDelivery: 'Регулярная доставка',
    b2bAdvInvoice: 'Налоговые накладные',
    /* end localized slogans */
  },
  en: {
    appName: 'Craft Food Factory',
    portalTitle: 'Order Portal',
    login: 'Login',
    logout: 'Logout',
    email: 'Email',
    password: 'Password',
    signIn: 'Sign In',
    dashboard: 'Dashboard',
    newOrder: 'New Order',
    orderHistory: 'Order History',
    repeatOrder: 'Repeat Order',
    documents: 'Documents',
    outstandingBalance: 'Outstanding Balance',
    companies: 'Companies',
    products: 'Products',
    productCategories: 'Product Categories',
    orders: 'Orders',
    production: 'Production',
    shipping: 'Shipping',
    payments: 'Payments',
    users: 'Users',
    settings: 'Settings',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    create: 'Create',
    submit: 'Submit',
    close: 'Close',
    confirm: 'Confirm',
    search: 'Search',
    name: 'Name',
    phone: 'Phone',
    address: 'Address',
    quantity: 'Quantity',
    price: 'Price',
    total: 'Total',
    status: 'Status',
    date: 'Date',
    actions: 'Actions',
    welcome: 'Welcome',
    selectLanguage: 'Select Language',
    monday: 'Monday',
    thursday: 'Thursday',
    today: 'Today',
    deliveryLocation: 'Delivery Location',
    company: 'Company',
    contactPerson: 'Contact Person',
    paymentTerms: 'Payment Terms',
    notes: 'Notes',
    orderNumber: 'Order Number',
    plannedShipmentDate: 'Planned Shipment Date',
    totalAmount: 'Total Amount',
    deliveryCost: 'Delivery Cost',
    subtotal: 'Subtotal',
    unitPrice: 'Unit Price',
    orderedQuantity: 'Ordered Quantity',
    actualShipped: 'Actual Shipped',
    pricingGroup: 'Pricing Group',
    clientType: 'Client Type',
    deliveryMethod: 'Delivery Method',
    addToCart: 'Add',
    placeOrder: 'Place Order',
    orderSuccess: 'Order Successfully Created',
    copyPaymentInfo: 'Copy Payment Info',
    copyDeliveryInfo: 'Copy Delivery Info',
    copied: 'Copied',
    overdue: 'Overdue',
    paid: 'Paid',
    unpaid: 'Unpaid',
    productionTotals: 'Production Totals',
    boxes: 'boxes',
    packs: 'packs',
    markAsInProduction: 'Mark In Production',
    markAsPacked: 'Mark as Packed',
    markAsShipped: 'Mark as Shipped',
    overallStats: 'Overall Stats',
    newOrders: 'New Orders',
    shippingToday: 'Shipping Today',
    totalRevenue: 'Total Revenue',
    /* navigation */
    navHome: 'Home',
    navAbout: 'About',
    navBrands: 'Brands',
    navContacts: 'Contact',
    register: 'Register',
    myPortal: 'My Portal',
    /* hero / home */
    heroHeadline: 'Honest Food for Better Living',
    heroSub: 'Creating honest food for modern life. Simple ingredients. Clean labels. Better choices, every day.',
    heroCtaPrimary: 'Place Order',
    heroCtaSecondary: 'Discover Brands',
    /* values */
    valuesTitle: 'Our Values',
    valHonest: 'Honest Composition',
    valNatural: 'Natural Ingredients',
    valBetterChoice: 'Better Choice',
    valQuality: 'Quality Without Compromise',
    valTrust: 'Trusted by Families',
    /* brand architecture */
    brandArchTitle: 'Our Brands',
    brandArchSub: 'Fresh flatbread and natural desserts',
    masterBrandTag: 'CRAFTFOOD',
    subBrandTag: 'Brand',
    ourBrands: 'Our Brands',
    lavashCardDesc: 'Fresh flatbread for homes, cafés, restaurants and foodservice.',
    veloraCardDesc: 'Desserts made from natural ingredients for modern life.',
    lavashShort: 'Modern Flatbread',
    veloraShort: 'Desserts',
    veloraSoon: 'Coming Soon',
    /* about */
    aboutTitle: 'About',
    missionTitle: 'Mission',
    missionBody: 'Creating honest food for modern life.',
    visionTitle: 'Vision',
    visionBody: 'An international food company creating the next generation of trusted food brands.',
    philosophyTitle: 'Philosophy',
    philosophyBody: 'Clean ingredients. Simple recipes. A better choice, every day.',
    /* lavash page */
    lavashTagline: 'Eat Better. Live Better.',
    lavashIntro: 'A modern foundation for healthy eating — a better alternative to ordinary bread.',
    lavashAdv: 'LAVASH Advantages',
    advNoYeast: 'No Yeast',
    advNoPreservatives: 'No Preservatives',
    advClean: 'Clean Ingredients',
    advVersatile: 'Versatile',
    catalogPreview: 'Product Catalog',
    ctaLoginToOrder: 'Log in to order',
    /* velora page */
    veloraTagline: 'Enjoy Better. Live Better.',
    veloraIntro: 'A new generation of modern desserts. An everyday indulgence — made with care.',
    veloraAdv: 'VELORA Advantages',
    advLessSugar: 'Less Sugar',
    /* contacts */
    contactsTitle: 'Contact',
    contactsForm: 'Write to us',
    contactName: 'Your name',
    contactMessage: 'Message',
    sendMessage: 'Send',
    /* footer */
    footerTagline: 'Building the next generation of trusted food brands for modern life in Korea.',
    footerBrands: 'Brands',
    footerCompany: 'Company',
    /* catalog / cart */
    catalogTitle: 'Catalog',
    cart: 'Cart',
    yourCart: 'Your Cart',
    cartEmpty: 'Your cart is empty',
    checkout: 'Checkout',
    perBox: '/box',
    inCart: 'In cart',
    comingSoon: 'Coming Soon',
    notifyMe: 'Notify me at launch',
    /* localized slogans (brand names stay in latin) */
    tagCraftfood: 'Honest Food for Better Living',
    tagCraftfoodShort: 'Honest Food · Better Living',
    tagLavashSub: 'Modern Flatbread',
    tagLavashSlogan: 'Eat Better. Live Better.',
    tagVeloraSub: 'Created with care',
    tagVeloraSlogan: 'Enjoy Better. Live Better.',
    heroLine1: 'Honest Food',
    heroLine2: 'for Better',
    heroLine3: 'Living.',
    loginAside: 'Honest food. Better living.',
    becomePartner: 'Become a partner.',
    masterBrand: 'CRAFTFOOD',
    subBrand: 'BRAND',
    oneMasterTwoBrands: 'Our Brands',
    betterBreadBetterLife: 'Better bread. Better life.',
    sixSizes: '6 sizes. One character.',
    readyToOrder: 'Ready to place your order?',
    registerInMinute: 'Register your business in under a minute. Start ordering LAVASH right away.',
    brandsH1Line1: 'One family.',
    brandsH1Line2: 'Many tastes.',
    contactsH1Line1: "Let's",
    contactsH1Line2: 'talk.',
    lavashTagLine: 'Modern Flatbread · Eat Better. Live Better.',
    veloraTagLine: 'Modern Desserts · Enjoy Better. Live Better.',
    loginAsideSub: 'B2B order portal for CRAFTFOOD partners. One login. Two brands. Endless freshness.',
    veloraComingSoonHint: 'VELORA desserts will be available in the unified cart soon. One order. Two brands.',
    b2bNoticeTag: 'B2B Wholesale Platform',
    b2bNoticeTitle: 'Pricing and purchase terms are available after registration',
    b2bNoticeBody: 'CRAFTFOOD is a B2B wholesale ordering platform for restaurants, cafés and stores. After registering your business, you will see wholesale prices for each product, volume discounts, delivery terms and available payment methods. Registration takes 1 minute and you can order immediately.',
    b2bAdvWholesale: 'Wholesale Pricing',
    b2bAdvVolume: 'Volume Discounts',
    b2bAdvDelivery: 'Recurring Delivery',
    b2bAdvInvoice: 'Tax Invoices',
  },
  uz: {
    appName: 'Craft Food Factory',
    portalTitle: 'Buyurtma Portali',
    login: 'Kirish',
    logout: 'Chiqish',
    email: 'Email',
    password: 'Parol',
    signIn: 'Kirish',
    dashboard: 'Boshqaruv paneli',
    newOrder: 'Yangi buyurtma',
    orderHistory: 'Buyurtmalar tarixi',
    repeatOrder: 'Buyurtmani takrorlash',
    documents: 'Hujjatlar',
    outstandingBalance: 'Qarz',
    companies: 'Kompaniyalar',
    products: 'Mahsulotlar',
    productCategories: 'Mahsulot kategoriyalari',
    orders: 'Buyurtmalar',
    production: 'Ishlab chiqarish',
    shipping: 'Yetkazib berish',
    payments: "To'lovlar",
    users: 'Foydalanuvchilar',
    settings: 'Sozlamalar',
    save: 'Saqlash',
    cancel: 'Bekor qilish',
    delete: "O'chirish",
    edit: 'Tahrirlash',
    add: "Qo'shish",
    create: 'Yaratish',
    submit: 'Yuborish',
    close: 'Yopish',
    confirm: 'Tasdiqlash',
    search: 'Qidirish',
    name: 'Ism',
    phone: 'Telefon',
    address: 'Manzil',
    quantity: 'Miqdor',
    price: 'Narx',
    total: 'Jami',
    status: 'Holat',
    date: 'Sana',
    actions: 'Amallar',
    welcome: 'Xush kelibsiz',
    selectLanguage: 'Tilni tanlang',
    monday: 'Dushanba',
    thursday: 'Payshanba',
    today: 'Bugun',
    deliveryLocation: 'Yetkazib berish manzili',
    company: 'Kompaniya',
    contactPerson: "Aloqa shaxsi",
    paymentTerms: "To'lov shartlari",
    notes: 'Eslatmalar',
    orderNumber: 'Buyurtma raqami',
    plannedShipmentDate: 'Rejalashtirilgan jo\'natish sanasi',
    totalAmount: 'Umumiy summa',
    deliveryCost: 'Yetkazib berish narxi',
    subtotal: 'Oraliq jami',
    unitPrice: 'Birlik narxi',
    orderedQuantity: 'Buyurtma miqdori',
    actualShipped: "Haqiqiy jo'natilgan",
    pricingGroup: 'Narx guruhi',
    clientType: 'Mijoz turi',
    deliveryMethod: 'Yetkazib berish usuli',
    addToCart: "Qo'shish",
    placeOrder: 'Buyurtma berish',
    orderSuccess: 'Buyurtma muvaffaqiyatli yaratildi',
    copyPaymentInfo: "To'lov ma'lumotlarini nusxalash",
    copyDeliveryInfo: "Yetkazib berish ma'lumotlarini nusxalash",
    copied: 'Nusxalandi',
    overdue: 'Muddati o\'tgan',
    paid: "To'langan",
    unpaid: "To'lanmagan",
    productionTotals: 'Ishlab chiqarish jamlari',
    boxes: 'quti',
    packs: 'paket',
    markAsInProduction: 'Ishlab chiqarishda',
    markAsPacked: 'Qadoqlandi',
    markAsShipped: "Jo'natildi",
    overallStats: 'Umumiy statistika',
    newOrders: 'Yangi buyurtmalar',
    shippingToday: 'Bugun jo\'natish',
    totalRevenue: 'Umumiy daromad',
    /* navigation */
    navHome: 'Bosh sahifa',
    navAbout: 'Kompaniya',
    navBrands: 'Brendlar',
    navContacts: 'Aloqa',
    register: "Ro'yxatdan o'tish",
    myPortal: 'Mening portalim',
    /* hero / home */
    heroHeadline: 'Halol oziq-ovqat — yaxshi hayot uchun',
    heroSub: 'Zamonaviy hayot uchun halol oziq-ovqat yaratamiz. Sof tarkib. Aniq mahsulotlar.',
    heroCtaPrimary: 'Buyurtma berish',
    heroCtaSecondary: 'Brendlar bilan tanishish',
    /* values */
    valuesTitle: 'Bizning qadriyatlarimiz',
    valHonest: 'Halol tarkib',
    valNatural: 'Tabiiy ingredientlar',
    valBetterChoice: "Yaxshiroq tanlov",
    valQuality: 'Murosasiz sifat',
    valTrust: "Oilalarning ishonchi",
    /* brand architecture */
    brandArchTitle: 'Bizning brendlarimiz',
    brandArchSub: 'Yangi lavash va tabiiy desertlar',
    masterBrandTag: 'CRAFTFOOD',
    subBrandTag: 'Brend',
    ourBrands: 'Bizning brendlarimiz',
    lavashCardDesc: "Uy, kafe, restoran va umumiy ovqatlanish korxonalari uchun yangi lavash.",
    veloraCardDesc: 'Zamonaviy hayot uchun tabiiy ingredientlardan tayyorlangan desertlar.',
    lavashShort: 'Modern Flatbread',
    veloraShort: 'Desserts',
    veloraSoon: 'Tez orada',
    /* about */
    aboutTitle: 'Biz haqimizda',
    missionTitle: 'Missiya',
    missionBody: 'Zamonaviy hayot uchun halol oziq-ovqat yaratamiz.',
    visionTitle: "Ko'rinish",
    visionBody: "Yangi avlod ishonchli brendlarini yaratuvchi xalqaro food-kompaniya.",
    philosophyTitle: 'Falsafa',
    philosophyBody: 'Sof ingredientlar. Sodda retseptlar. Har kuni yaxshiroq tanlov.',
    /* lavash page */
    lavashTagline: 'Eat Better. Live Better.',
    lavashIntro: "Sog'lom ovqatlanish uchun zamonaviy asos.",
    lavashAdv: 'LAVASH afzalliklari',
    advNoYeast: 'Xamirturushsiz',
    advNoPreservatives: 'Konservantsiz',
    advClean: 'Sof tarkib',
    advVersatile: 'Ko\'p qirrali',
    catalogPreview: 'Mahsulotlar katalogi',
    ctaLoginToOrder: 'Buyurtma uchun kiring',
    /* velora page */
    veloraTagline: 'Enjoy Better. Live Better.',
    veloraIntro: 'Yangi avlod zamonaviy desertlari. Har kuni uchun desert — siz uchun g\'amxo\'rlik bilan.',
    veloraAdv: 'VELORA afzalliklari',
    advLessSugar: 'Kam shakar',
    /* contacts */
    contactsTitle: 'Aloqa',
    contactsForm: 'Bizga yozing',
    contactName: 'Ismingiz',
    contactMessage: 'Xabar',
    sendMessage: 'Yuborish',
    /* footer */
    footerTagline: "Zamonaviy hayot uchun yangi avlod ishonchli food brendlarini yaratamiz.",
    footerBrands: 'Brendlar',
    footerCompany: 'Kompaniya',
    /* catalog / cart */
    catalogTitle: 'Katalog',
    cart: 'Savat',
    yourCart: 'Sizning savatingiz',
    cartEmpty: "Savat bo'sh",
    checkout: 'Rasmiylashtirish',
    perBox: '/quti',
    inCart: 'Savatda',
    comingSoon: 'Tez orada',
    /* localized slogans (brand names stay in latin) */
    tagCraftfood: 'Halol oziq-ovqat — yaxshi hayot uchun',
    tagCraftfoodShort: "Halol oziq-ovqat · Yaxshi hayot",
    tagLavashSub: 'Zamonaviy yupqa non',
    tagLavashSlogan: "Yaxshi yeb. Yaxshi yasha.",
    tagVeloraSub: "G'amxo'rlik bilan yaratilgan",
    tagVeloraSlogan: "Zavqlan. Yaxshiroq yasha.",
    heroLine1: 'Halol oziq-ovqat,',
    heroLine2: "yaxshi hayot",
    heroLine3: 'uchun.',
    loginAside: "Halol oziq-ovqat. Yaxshi hayot.",
    becomePartner: "Hamkor bo'ling.",
    masterBrand: 'CRAFTFOOD',
    subBrand: 'BREND',
    oneMasterTwoBrands: 'Bizning brendlarimiz',
    betterBreadBetterLife: 'Yaxshi non. Yaxshi hayot.',
    sixSizes: "6 ta o'lcham. Bitta xarakter.",
    readyToOrder: 'Buyurtma berishga tayyormisiz?',
    registerInMinute: "Bir daqiqada biznesingizni ro'yxatdan o'tkazing. Hozir LAVASH buyurtma qiling.",
    brandsH1Line1: 'Bir oila.',
    brandsH1Line2: "Ko'p ta'mlar.",
    contactsH1Line1: "Keling",
    contactsH1Line2: "gaplashamiz.",
    lavashTagLine: "Zamonaviy yupqa non · Yaxshi yeb. Yaxshi yasha.",
    veloraTagLine: "Zamonaviy desertlar · Zavqlan. Yaxshiroq yasha.",
    veloraComingSoonHint: "VELORA desertlari tez orada umumiy savatda paydo bo'ladi.",
    b2bNoticeTag: 'B2B ulgurji platforma',
    b2bNoticeTitle: "Narxlar va xarid shartlari ro'yxatdan o'tgandan keyin ko'rsatiladi",
    b2bNoticeBody: "CRAFTFOOD — restoranlar, kafelar va do'konlar uchun B2B ulgurji buyurtma platformasi.",
    b2bAdvWholesale: 'Ulgurji narxlar',
    b2bAdvVolume: 'Hajm chegirmalari',
    b2bAdvDelivery: 'Muntazam yetkazib berish',
    b2bAdvInvoice: 'Soliq hujjatlari',
    /* end localized slogans */
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('cff_language') || 'ru';
  });

  useEffect(() => {
    localStorage.setItem('cff_language', language);
  }, [language]);

  const t = (key) => translations[language]?.[key] || translations.en[key] || key;

  const getProductName = (product) => {
    return product[`product_name_${language}`] || product.product_name_ko;
  };

  const getCategoryName = (category) => {
    return category[`name_${language}`] || category.name_ko;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, getProductName, getCategoryName }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);

export const languages = [
  { code: 'ko', name: '한국어', flag: '🇰🇷' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'uz', name: "O'zbekcha", flag: '🇺🇿' },
];
